import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from '@uturn/ui-kit';
import { useTranslation } from 'react-i18next';

type Props = {
	open: boolean;
	onConfirm: () => void;
	onCancel: () => void;
};

export const ConfirmQuotedShipmentUpdateModal = ({
	open,
	onConfirm,
	onCancel,
}: Props) => {
	const { t } = useTranslation();

	return (
		<AlertDialog open={open}>
			<AlertDialogContent className="max-w-[25rem] md:max-w-[40rem]">
				<AlertDialogHeader>
					<AlertDialogTitle>
						{t(
							'pages.shipment-detail.confirm-quote-invalidation.title',
							'Quotes will be lost',
						)}
					</AlertDialogTitle>
					<AlertDialogDescription>
						{t(
							'pages.shipment-detail.confirm-quote-invalidation.description',
							'This update may impact existing quotes from carriers. If you continue, the current quotes will be removed and carriers will be notified to place new quotes. Do you wish to proceed?',
						)}
					</AlertDialogDescription>
				</AlertDialogHeader>

				<AlertDialogFooter>
					<AlertDialogCancel onClick={onCancel}>
						{t(
							'pages.shipment-detail.confirm-quote-invalidation.cancel',
							'Cancel',
						)}
					</AlertDialogCancel>
					<AlertDialogAction onClick={onConfirm}>
						{t(
							'pages.shipment-detail.confirm-quote-invalidation.confirm',
							'Update shipment',
						)}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
};
